import { render, staticRenderFns } from "./sendMange.vue?vue&type=template&id=fc606498&scoped=true"
import script from "./sendMange.vue?vue&type=script&lang=js"
export * from "./sendMange.vue?vue&type=script&lang=js"
import style0 from "./sendMange.vue?vue&type=style&index=0&id=fc606498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc606498",
  null
  
)

export default component.exports